/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CouponGrant } from './CouponGrant';
import { PurchaseGrant } from './PurchaseGrant';
const AccessGrantedParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('access-granted')],
    [
        'grant',
        /* #__PURE__ */ parsers.taggedUnion('type', [
            ['purchase', PurchaseGrant],
            ['coupon', CouponGrant],
        ]),
    ],
]);
export class AccessGranted extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AccessGrantedParser.decode(input).map(res => new AccessGranted(res));
    }
    static unsafeDecode(input) {
        return AccessGranted.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessGrantedParser.encode(data);
    }
    static schema() {
        return AccessGrantedParser.schema();
    }
}
